import { useId } from 'react'
import { Link, useLocation } from 'react-router'
import { Button } from './button.tsx'
import { Modal } from './shared/modal.tsx'

export interface UpdateAvailableModalProps {
  open: boolean
  onReload: () => void
  onDismiss: () => void
}

// RAL-137: no countdown, no forced reload — see use-version-check.ts for why. The user decides
// when to reload; dismissing just gets out of the way until a newer version ships.
export function UpdateAvailableModal({ open, onReload, onDismiss }: UpdateAvailableModalProps) {
  const titleId = useId()
  const location = useLocation()

  return (
    <Modal open={open} onClose={onDismiss} titleId={titleId} className="max-w-md">
      <div className="flex flex-col gap-4 p-5">
        <div className="flex flex-col gap-1.5">
          <p className="font-mono text-[10px] uppercase tracking-[0.1em] text-signal-oxide">Update available</p>
          <h3 id={titleId} className="font-display text-lg font-semibold text-ink-primary">
            A newer version of Rally is ready
          </h3>
        </div>

        <p className="font-display text-[11px] leading-relaxed text-ink-secondary">
          Reload to pick up the latest fixes and features. Nothing you're working on is affected until you do.
        </p>

        <Link
          to="/changelog"
          state={{ from: location.pathname }}
          onClick={onDismiss}
          className="font-mono text-[10px] uppercase tracking-[0.1em] text-ink-secondary underline hover:text-ink-primary"
        >
          See what's new →
        </Link>

        <div className="flex items-center gap-3 border-t border-border-hairline pt-4">
          <Button onClick={onReload}>Reload now</Button>
          <Button variant="secondary" onClick={onDismiss}>
            Later
          </Button>
        </div>
      </div>
    </Modal>
  )
}
